module.exports = __webpack_public_path__ + "img/approval-bg.cfd52a5.png";